import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { BookmarkService } from 'src/app/service/data/bookmark.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { BookmarkStateService } from 'src/app/service/state/bookmark-state.service'
import { CollectionItem } from '../../models/main/collection'
import { DdcChooseDialogOneComponent } from '../ddc-choose-dialog-one/ddc-choose-dialog-one.component'

@Component({
  selector: 'ddc-bookmark',
  templateUrl: './ddc-bookmark.component.html',
  styleUrl: './ddc-bookmark.component.scss',
})
export class DdcBookmarkComponent implements OnInit {
  @Input('is_bookmarked') _isBookmarked: boolean
  @Input('show_count') _showCount: boolean = true
  @Input('content_type_id') _content_type_id: number
  @Input('obj_id') _obj_id: number
  @Input('count') _count: number
  @Input('content_item') _contentItem: CollectionItem // The actual content item for state management

  @Output() bookmarkChanged = new EventEmitter<boolean>()

  constructor(
    private logger: DdcLoggerService,
    public dialog: MatDialog,
    private bookmark_service: BookmarkService,
    private bookmarkStateService: BookmarkStateService,
  ) {}

  ngOnInit(): void {}

  toggleBookmark(): void {
    this.logger.info('DdcBookmarkComponent: toggleBookmark()')

    if (this._isBookmarked) {
      // Remove bookmark
      this._isBookmarked = !this._isBookmarked
      this.bookmark_service
        .bookmark(false, this._content_type_id, this._obj_id)
        .subscribe((res: any) => {
          if (res.detail == 'bookmarked') {
            this._count++
          } else if (res.detail == 'unbookmarked') {
            this._count--
            // Remove from bookmark state
            if (this._contentItem) {
              this.bookmarkStateService.removeBookmarkItem(
                this._contentItem.id,
                this._contentItem.type,
              )
            }
          }
          this.bookmarkChanged.emit(this._isBookmarked)
        })
    } else {
      // Add bookmark
      this._isBookmarked = !this._isBookmarked
      const dialogRef = this.dialog.open(DdcChooseDialogOneComponent, {
        data: {
          type: 'bookmark-group',
          is_bookmarked: false,
          content_type_id: this._content_type_id,
          obj_id: this._obj_id,
          content_item: this._contentItem, // Pass the content item to the dialog
        },
      })

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'added') {
          this._count++
          // The dialog should handle adding to bookmark state
        } else {
          this._isBookmarked = !this._isBookmarked
        }
        this.bookmarkChanged.emit(this._isBookmarked)
      })
    }
  }
}
